import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ce6ca692"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "header--content"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "header--content"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "sub-content" }

import { HomeOutlined, SettingOutlined } from '@ant-design/icons-vue'
import { onBeforeUpdate, onMounted, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import {
  getTokenExpirationTime,
  isLoggedIn as authIsLoggedIn,
  logout,
  updateToken,
  token,
  differenceInSecondsFromNow
} from 'src/services/auth.service'
import { useStore } from 'src/store'
import MenuDropdown from 'src/components/base/menu/MenuDropdown.vue'
import MenuItem from 'src/components/base/menu/MenuItem.vue'
import router from 'src/router'
import { getAllComplexes } from 'src/services/complex.service'
import { getAllRealEstates } from 'src/services/realEstate.service'
import { getAllConstructions } from 'src/services/construction.service'
import { storeToRefs } from 'pinia'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore()
const route = useRoute()
const { editMode } = storeToRefs(store)
const logo = ref<string>('')
const selectedRealm = ref<string | null>(null)
const accessToken = ref()
const activeMenuItem = ref<string[]>([])
const isLoggedIn = ref<boolean>(false)
const refreshTimer = ref<number | undefined>(undefined)

onMounted(async () => {
  selectedRealm.value = localStorage.getItem('realmId')
  logo.value = require('@/assets/db-white.svg')
  activeMenuItem.value = store.getActiveMenuItem()
  isLoggedIn.value = await authIsLoggedIn()
  if (isLoggedIn.value) {
    store.updateLoginStatus(true)
    await initialDataFetch()
  }
})

onBeforeUpdate(() => {
  selectedRealm.value = localStorage.getItem('realmId')
})

async function initialDataFetch() {
  const complexes = await getAllComplexes()
  store.allComplexes = complexes ? complexes : []
  const realEstates = await getAllRealEstates()
  store.allRealEstates = realEstates ? realEstates : []
  const constructions = await getAllConstructions()
  store.allConstructions = constructions ? constructions : []
  // parse jwt token to get roles
  accessToken.value = token()
  const tokenPayload = accessToken.value ? JSON.parse(atob(accessToken.value.split('.')[1])) : null
  store.hasRoleAdmin = tokenPayload ? tokenPayload.realm_access.roles.includes('ROLE_ADMIN') : false
}

function selectRealm() {
  router.push('/realm')
}
function setTokenRefresh() {
  if (!selectedRealm.value) {
    console.debug('No realm selected, not setting token refresh')
    return
  }
  clearTimeout(refreshTimer.value)
  const tokenExpirationTime = getTokenExpirationTime(selectedRealm.value) ?? 0 // We have interpreted this time as seconds since epoch (local agnostic)
  const difference = differenceInSecondsFromNow(tokenExpirationTime)
  const differenceMinusOneMinute = difference - 60
  refreshTimer.value = setTimeout(async () => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const tokenRequest = await updateToken(selectedRealm.value!) // can safely use ! here because we have checked for selectedRealm.value above
    if (tokenRequest) accessToken.value = tokenRequest
  }, differenceMinusOneMinute * 1000)
}
watch(accessToken, () => {
  setTokenRefresh()
})
// active tab according to routing
watch(route, () => {
  store.updateActiveMenuItem(route.path.split('/', 4))
  activeMenuItem.value = store.getActiveMenuItem()
})
// correct tab stays active when editing
watch(
  activeMenuItem,
  () => {
    if (editMode.value) {
      const oldActivePage = ref<string[]>([])
      oldActivePage.value = route.path.split('/', 4)
      // fix active tab
      if (oldActivePage.value[1] !== activeMenuItem.value[1]) {
        store.updateActiveMenuItem(oldActivePage.value)
        activeMenuItem.value = store.getActiveMenuItem()
      }
    }
  },
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, { class: "layout-main" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout_header, { class: "header" }, {
        default: _withCtx(() => [
          (isLoggedIn.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("img", {
                  src: logo.value,
                  alt: "Digital Buildings",
                  class: "logo",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/')))
                }, null, 8, _hoisted_2),
                _createVNode(_component_a_typography_text, { class: "realm-title" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(selectedRealm.value), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(logout)()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Log out")
                  ]),
                  _: 1
                })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("img", {
                  src: logo.value,
                  alt: "Digital Buildings",
                  class: "logo",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push('/')))
                }, null, 8, _hoisted_4),
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (selectRealm())),
                  style: {"margin-left":"auto"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Log in")
                  ]),
                  _: 1
                })
              ]))
        ]),
        _: 1
      }),
      _createVNode(_component_a_layout, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_layout_sider, {
            class: "sider",
            width: "16vw"
          }, {
            default: _withCtx(() => [
              (isLoggedIn.value)
                ? (_openBlock(), _createBlock(_component_a_menu, {
                    key: 0,
                    class: "sider--content",
                    mode: "inline",
                    selectedKeys: activeMenuItem.value,
                    "onUpdate:selectedKeys": _cache[4] || (_cache[4] = ($event: any) => ((activeMenuItem).value = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(MenuDropdown, {
                        activeKey: "realm-management",
                        title: "Realm management"
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_unref(SettingOutlined))
                        ]),
                        links: _withCtx(() => [
                          _createVNode(MenuItem, {
                            activeKey: "realm-settings",
                            routerLink: "/realm-management/realm-settings",
                            title: "Realm settings"
                          }),
                          _createVNode(MenuItem, {
                            activeKey: "authority-data",
                            "router-link": "/realm-management/authority-data",
                            title: "Fetch authority data"
                          }),
                          _createVNode(MenuDropdown, {
                            activeKey: "access-management",
                            title: "Access management"
                          }, {
                            links: _withCtx(() => [
                              _createVNode(MenuItem, {
                                activeKey: "users",
                                routerLink: "/realm-management/access-management/users",
                                title: "Users"
                              }),
                              _createVNode(MenuItem, {
                                activeKey: "groups",
                                routerLink: "/realm-management/access-management/groups",
                                title: "Groups"
                              }),
                              _createVNode(MenuItem, {
                                activeKey: "default-access",
                                routerLink: "/realm-management/access-management/default-access",
                                title: "Default access"
                              }),
                              _createVNode(MenuItem, {
                                activeKey: "navvis-credentials",
                                routerLink: "/realm-management/access-management/navvis-credentials",
                                title: "Navvis Credentials"
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(MenuDropdown, {
                        activeKey: "my-portfolio",
                        title: "My portfolio"
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_unref(HomeOutlined))
                        ]),
                        links: _withCtx(() => [
                          _createVNode(MenuItem, {
                            activeKey: "complexes",
                            routerLink: "/my-portfolio/complexes",
                            title: "Complexes"
                          }),
                          _createVNode(MenuItem, {
                            activeKey: "real-estates",
                            routerLink: "/my-portfolio/real-estates",
                            title: "Real estates"
                          }),
                          _createVNode(MenuItem, {
                            activeKey: "constructions",
                            routerLink: "/my-portfolio/constructions",
                            title: "Constructions"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(MenuDropdown, {
                        activeKey: "elements",
                        title: "Elements"
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_unref(HomeOutlined))
                        ]),
                        links: _withCtx(() => [
                          _createVNode(MenuDropdown, {
                            activeKey: "zones",
                            routerLink: "/elements/zones",
                            title: "Zones"
                          }, {
                            links: _withCtx(() => [
                              _createVNode(MenuItem, {
                                activeKey: "zoneCategories",
                                routerLink: "/elements/zones/categories",
                                title: "Categories"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(MenuDropdown, {
                            activeKey: "POIs",
                            routerLink: "/elements/POIs",
                            title: "POIs",
                            isOpen: true
                          }, {
                            links: _withCtx(() => [
                              _createVNode(MenuItem, {
                                activeKey: "poiCategories",
                                routerLink: "/elements/POIs/categories",
                                title: "Categories"
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["selectedKeys"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_a_layout, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_layout_content, { class: "content" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_router_view, null, {
                      default: _withCtx(({ Component }) => [
                        (_openBlock(), _createBlock(_KeepAlive, { include: "home" }, [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                        ], 1024))
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})